import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

const openPublicPdf = async (event, path) => {
    if (!Capacitor.isNativePlatform()) return;

    event.preventDefault();

    const baseUrl = process.env.REACT_APP_PUBLIC_URL;

    if (!baseUrl) {
        console.error('REACT_APP_PUBLIC_URL is not configured; cannot open public PDF');
        return;
    }

    await Browser.open({
        url: `${baseUrl.replace(/\/+$/, '')}${path}`,
    });
};

export default openPublicPdf;
